import {
  all,
  fork,
} from 'redux-saga/effects';

import { watchInitApplication } from './initApplication';
import { watchGroupOrders } from './requests/groupOrders';
import { watchOrderSummary } from './orderSummary';
import { watchOrderStatus } from './services/updateStatus';
import { watchAnalytics } from './analytics';
import { watchOrderTracker } from './orderTracker';
import { watchAmendAppointment } from './amendAppointment';

export default function* rootSaga(): Generator {
  yield all([
    fork(watchInitApplication),
    fork(watchGroupOrders),
    fork(watchOrderSummary),
    fork(watchOrderStatus),
    fork(watchAnalytics),
    fork(watchOrderTracker),
    fork(watchAmendAppointment),
  ]);
}
